import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import BaseInput from './base';

const validate = val =>
  string()
    .required('Enter your mobile number')
    .min(10, 'Please enter a valid mobile number')
    .validate(val.replace(/[^\d]/g, '').toString())
    .then(() => null)
    .catch(err => err.errors.join(', '));

const Input = inputProps => (
  <BaseInput
    label="Mobile Number"
    type="tel"
    name="phone"
    maxLength={15}
    transparent
    useLocalState={false}
    {...inputProps}
  />
);

const PhoneNumber = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    format="(###) ###-####"
    mask="_"
    onValueChange={values =>
      onChange({ ...values, name: 'phone', type: 'tel' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

PhoneNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string
};

PhoneNumber.defaultProps = {
  onTouched: null,
  value: '',
  error: ''
};

export default PhoneNumber;
